import styled from "styled-components";
import { colors } from "theme";

export const TableWrapper = styled.div`
  height: calc(100vh - 336px);
  /* height: 100vh; */
  display: inline-block;
  width: 100%;
  border: 1px solid rgb(228, 228, 228);
  border-radius: 8px;
`;

export const ContentRow = {
  borderBottom: "0.5px solid rgb(63, 157, 255)",
  fontFamily: "Inter !important",
  color: colors.defaultFontColor,
  fontWeight: "500",
  backgroundColor: "white",
  overflow: "hidden",
  wordWrap: "break-word",
};

export const ContentRowGrey = {
  borderBottom: "0.5px solid rgba(228, 228, 228, 1)",
  fontFamily: "Inter !important",
  color: colors.defaultFontColor,
  fontWeight: "500",
  backgroundColor: "white",
  overflow: "hidden",
  wordWrap: "break-word",
};

export const HeaderRow = {
  backgroundColor: "#E5E2EF",
  borderBottom: "none",
  fontFamily: "Inter",
  fontWeight: "600",
  lineHeight: '18px',
  whiteSpace: "nowrap",
  color: colors.primaryColor,
  paddingTop: "14px",
  paddingBottom: "14px",
  whiteSpace: 'normal',
};

export const MaterialTable = {
  tableLayout: "fixed",
  border: "none",
  borderCollapse: "separate",
  "*": {
    fontSize: "14px !important",
  },
};

export const MaterialTableContainer = {
  borderRadius: "8px !important",
  scrollbarWidth: "thin",
};

export const BoxHeading = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
  align-items: center;
`;

export const Download = styled.div`
  margin-top: 0px;
  border: 0px;
  color: rgb(255, 255, 255);
  background: #2354D4;
  padding: 10px 20px;
  display: flex;
  padding: 1.2rem 2rem;
  justify-content: space-between;
  align-items: center;
  letter-spacing: 0.5px;
  font-size: 0px;
  cursor: pointer;
  letter-spacing: 0.5px;
  height: 44px;
  width: max-content;
  border-radius: 10px;
  margin-right: 10px;
  transition: 0.2s ease-in-out all;
`;

export const SearchfilterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #E5E2EF;
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 24px;
`;

export const EmpMisSearchFilterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #E5E2EF;
  width: 100%;
  border-radius: 6px;
`;

export const InputDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 15px;
  border-radius: 8px;
`;
export const FilterDiv = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  margin-right: 10px;
  width: 180px;
  height: 43px;
  margin: 0 14px;
  border-radius: 10px;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  z-index: 0;
  & > div {
    position: absolute;
    user-select: none;
    pointer-events: none;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
export const FilterImage = styled.img`
  position: absolute;
  height: 14px;
  top: 14px;
  left: 14px;
  z-index: 999;
  user-select: none;
  pointer-events: none;
`;

export const Dropdown = styled.select`
  display: flex;
  position: relative;
  width: 100%;
  border: none;
  font-family: "Avenir";
  font-size: 14px;
  padding: 10px 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.25px;
  padding-left: 36px;
  color: ${(props) => (props.color ? props.color : "rgba(0, 0, 0, 0.5)")};
  background-color: ${(props) => props.theme.accentColor};
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  &:hover,
  &:focus {
    outline: 0 !important;
  }
`;

export const Option = styled.option`
  color: ${(props) => (props.color ? props.color : "black")};
`;
